import StaffLoginForm from "@/components/Auth/StaffLoginForm";

export default function CollisionLoginPage() {
    return (
        <StaffLoginForm
            title="Collision / Body Login"
            subtitle="Sign in to the Collision & Body Shop portal"
            backgroundImage="/images/assets/global_collision_futuristic_1.png"
        />
    );
}
